export default {"src":"/_next/static/image/public/images/img_nodoc.01930c4b65f14287829e8afbd1469bd0.svg","height":116,"width":104};